import { useCallback, useEffect, useState } from 'react';
import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';

async function fetchFilterOptions(from, to) {
  const params = new URLSearchParams();
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  const queryString = params.toString();
  const url = `${QUALITY_SERVICE_API_URL}/filter-options${queryString ? `?${queryString}` : ''}`;
  const response = await api.get(url);
  return response.data;
}

function useFilterOptions(dateRange) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const formatDate = date => {
    if (!date) return null;
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  };

  const refetch = useCallback(async (isCancelled = () => false) => {
    setLoading(true);
    setError(null);
    setData(null);

    try {
      const fromStr = formatDate(dateRange?.startDate);
      const toStr = formatDate(dateRange?.endDate);
      const filterOptions = await fetchFilterOptions(fromStr, toStr);
      if (!isCancelled()) setData(filterOptions);
    } catch (err) {
      if (!isCancelled()) setError(err);
    } finally {
      if (!isCancelled()) setLoading(false);
    }
  }, [dateRange]);

  useEffect(() => {
    let isMounted = true;
    const isCancelled = () => !isMounted;

    refetch(isCancelled);

    return () => {
      isMounted = false;
    };
  }, [refetch]);

  return { data, loading, error, refetch };
}

export default useFilterOptions;
